import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";

export interface AdminUser {
  email: string;
  domain: string;
  lastOtpAttempt: string;
  lastAuthenticated: string | null;
  lastSession: string | null;
  otpRequestCount: number;
}

interface AdminUsersResponse {
  success: boolean;
  data: {
    users: AdminUser[];
  };
}

export function useAdminUsers() {
  return useQuery({
    queryKey: ["admin-users"],
    queryFn: async () => {
      const response = await apiGet<AdminUsersResponse>("/admin/users");
      return response.data;
    },
  });
}
